import { __assign } from 'tslib';
import { jsx, Fragment } from 'react/jsx-runtime';
import assert from 'assert';
import { Children, useEffect } from 'react';
import flattenChildren from 'react-keyed-flatten-children';
import { TabPanel } from './TabPanel.js';
import { useTabsContext } from './contexts/TabsContext.js';
import { TabPanelsProvider } from './contexts/TabsPanelsContext.js';

var TabPanels = function (_a) {
    var children = _a.children;
    var tabsContext = useTabsContext();
    if (!tabsContext) {
        throw new Error("TabPanels is rendered outside TabsProvider");
    }
    var panelItems = [];
    var panels = Children.map(flattenChildren(children), function (panel, index) {
        var _a, _b;
        assert(typeof panel === "object" &&
            // @ts-expect-error "using dom render properties"
            (panel.type === TabPanel || ((_a = panel.type) === null || _a === void 0 ? void 0 : _a.displayName) === "TabPanel"), "Only TabPanel elements can be direct children of a TabPanels");
        panelItems.push((_b = panel.props.item) !== null && _b !== void 0 ? _b : index);
        return (
        // Make each TabPanel aware of their own Index relative to the other tabs in TabPanelsList
        jsx(TabPanelsProvider, __assign({ value: {
                panelIndex: index,
            } }, { children: panel })));
    });
    useEffect(function () {
        tabsContext.tabPanels = panelItems;
    }, []);
    return jsx(Fragment, { children: panels });
};

export { TabPanels };
//# sourceMappingURL=TabPanels.js.map
